'use client';

import Button from '@enlighten/design-system/dist/Button';
import Grid from '@enlighten/design-system/dist/Grid';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';

import type { ManufacturerItem } from '@/constants/manufacturer';

export interface ManufacturerProps {
	data: ManufacturerItem[];
}

export default function Manufacturer({ data }: ManufacturerProps) {
	const [toggle, setToggle] = useState<boolean>(false);

	return (
		<>
			<Grid display={{ xs: 'flex', md: 'grid' }} gridTemplateColumns="repeat(4, 1fr)" flexDirection="column" gap={2} marginBottom={2}>
				{(toggle ? data : data.slice(0, 8)).map(({ manufacturer, storagePath, storageName, url }, i) => (
					<Link key={i} href={url} target="_blank" role="link">
						<Grid
							container
							direction="column"
							bgcolor="common.white"
							width="100%"
							height={{ xs: 80, md: 139 }}
							border={(theme) => `1px solid ${theme.palette.grey['300']}`}
							borderRadius="6px"
							overflow="hidden"
							sx={{
								':hover .MuiButton-root': {
									marginBottom: 0,
								},
							}}
						>
							<Grid
								container
								flex={1}
								justifyContent="center"
								alignItems="center"
								width="100%"
								sx={{
									'& img': {
										width: { xs: 90, md: '80%' },
										height: 'auto',
									},
								}}
							>
								<Image src={`https://cdn.solarconnect.kr/${storagePath}/${storageName}`} alt={manufacturer} width={200} height={100} priority />
							</Grid>
							<Button
								fullWidth
								sx={{
									fontSize: { xs: 14, md: 16 },
									fontWeight: 400,
									height: { xs: 32, md: 40 },
									borderRadius: 0,
									marginBottom: { xs: -4, md: -5 },
									transition: 'margin-bottom 0.3s ease',
									':hover': {
										bgcolor: 'primary.main',
									},
								}}
							>
								견적 문의하기
							</Button>
						</Grid>
					</Link>
				))}
			</Grid>
			{!toggle && (
				<Grid container justifyContent="center" height={52}>
					<Button
						variant="text"
						sx={{
							fontSize: 16,
							fontWeight: 400,
							color: 'grey.700',
							textDecoration: 'underline',
							padding: '13px 23px',
							':hover': {
								textDecoration: 'underline',
								bgcolor: 'transparent',
							},
						}}
						onClick={() => {
							setToggle(true);
						}}
					>
						더보기
					</Button>
				</Grid>
			)}
		</>
	);
}
